const shared = {
  radius: {
    small: '8px',
    medium: '12px',
    large: '18px',
    pill: '999px',
  },
  breakpoint: {
    mobile: '720px',
    tablet: '1024px',
  },
}

const lightColors = {
    primary: '#111B40',
    primaryHover: '#1B2A5B',
    primaryFill: '#111B40',
    primaryFillHover: '#1B2A5B',
    primaryAccent: '#52658F',
    primarySoft: '#EEF1F8',
    progressAccent: '#D94B6A',
    progressAccentAlt: '#F07B91',
    progressSoft: '#FFF1F4',
    secondary: '#EB005C',
    muiPrimary: '#111B40',
    background: '#FAFBFD',
    surface: '#FFFFFF',
    text: '#161B2B',
    textMuted: '#667085',
    border: '#E2E6EE',
    borderStrong: '#C7CEDA',
    success: '#23855B',
    warning: '#B5630A',
    danger: '#C43D4B',
    gray: '#BABABA',
    lightGray: '#DADADA',
    lightestGray: '#F6F6F6',
    skyblue: '#D7ECFF',
    topBar: 'rgba(255, 255, 255, 0.94)',
    mobileNav: 'rgba(255, 255, 255, 0.97)',
    surfaceTranslucent: 'rgba(255, 255, 255, 0.82)',
    focusRing: 'rgba(17, 27, 64, 0.3)',
    focusSoft: 'rgba(17, 27, 64, 0.12)',
    onPrimary: '#FFFFFF',
}

const darkColors = {
  // In dark mode, use the lighter blue only for small interactive accents.
  // Large filled areas keep the brand navy so the UI does not look inverted.
  primary: '#91A6D8',
  primaryHover: '#A4B6DF',
  primaryFill: '#1B2A52',
  primaryFillHover: '#263967',
  primaryAccent: '#A9B9DE',
  primarySoft: '#222D43',
  progressAccent: '#E66A84',
  progressAccentAlt: '#F18BA0',
  progressSoft: '#382530',
  secondary: '#F0759F',
  muiPrimary: '#91A6D8',
  background: '#111722',
  surface: '#1A2230',
  text: '#E8ECF4',
  textMuted: '#9DA8BA',
  border: '#2B3546',
  borderStrong: '#3B485C',
  success: '#67BE98',
  warning: '#DBA45E',
  danger: '#EA7B88',
  gray: '#7D899D',
  lightGray: '#3B485C',
  lightestGray: '#222B39',
  skyblue: '#23364E',
  topBar: 'rgba(17, 23, 34, 0.92)',
  mobileNav: 'rgba(27, 42, 82, 0.98)',
  surfaceTranslucent: 'rgba(26, 34, 48, 0.9)',
  focusRing: 'rgba(145, 166, 216, 0.42)',
  focusSoft: 'rgba(145, 166, 216, 0.18)',
  onPrimary: '#FFFFFF',
}

export function createAppTheme(mode = 'light') {
  const isDark = mode === 'dark'

  return {
    ...shared,
    mode: isDark ? 'dark' : 'light',
    colors: isDark ? darkColors : lightColors,
    shadow: isDark ? {
      low: '0 1px 2px rgba(0, 0, 0, 0.28)',
      medium: '0 14px 36px rgba(0, 0, 0, 0.38)',
    } : {
    low: '0 1px 2px rgba(17, 27, 64, 0.06)',
    medium: '0 12px 32px rgba(17, 27, 64, 0.12)',
    },
  }
}

const theme = createAppTheme('light')

export default theme
